'use client'

import { useEffect, useState } from 'react'
import { useLocalisation } from '../../i18n/client'
import { useAuth } from '@/tools/auth'
import { glovoRum, useErrorHandling } from '@/tools/o11y/client'
import { useToggles } from '@/tools/toggles/client'
import { getPreferredLanguage } from '@/user/profile/ui/components/language-management/use-cases'
import { useUserData } from '@/user/useUserData'

export const AuthStateGuard = () => {
  const { isLoggedIn } = useAuth()
  const { loadLanguageAndRefresh } = useLocalisation()
  const { execWithErrorTracking } = useErrorHandling()
  const { userData } = useUserData()
  const { setUser: setTogglesUser } = useToggles()

  const [isLoaded, setIsLoaded] = useState(false)

  // Preferred User Language
  useEffect(() => {
    execWithErrorTracking(async () => {
      if (!isLoggedIn || isLoaded) {
        return
      }
      const preferredLanguage = await getPreferredLanguage()
      await loadLanguageAndRefresh(preferredLanguage)
      setIsLoaded(true)
    })
  }, [execWithErrorTracking, isLoggedIn, loadLanguageAndRefresh, isLoaded])

  // RUM
  useEffect(() => {
    execWithErrorTracking(async () => {
      if (isLoggedIn && userData) {
        glovoRum.setUser({ id: userData.id })
        glovoRum.setContext('authenticated', true)
      } else {
        glovoRum.setContext('authenticated', false)
        glovoRum.clearUser()
      }
    })
  }, [execWithErrorTracking, userData, isLoggedIn])

  // Toggles - FwF
  useEffect(() => {
    execWithErrorTracking(async () => {
      if (isLoggedIn && userData) {
        setTogglesUser({ id: String(userData.id), email: userData.email })
        // should we refetch toggles or is this done automatically? - ask sergi
      } else {
        setTogglesUser(null)
      }
    })
  }, [execWithErrorTracking, userData, isLoggedIn, setTogglesUser])
  return <></>
}
